import { moment } from '@seiue/moment'
import { isNil, safeParseJSON } from '@seiue/util'
import { Divider } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'

import { RichTextRenderer } from 'packages/components/RichText'
import { Notification } from 'packages/sdks-next/growp'

/**
 * 获取通知富文本
 *
 * @param value - 通知内容
 * @param variables - 变量
 * @returns 富文本
 */
export const getNoticeRichtext = (
  value: string,
  variables: Record<string, string>
) => {
  const regex = /{{(.*?)}}/g
  return value.replace(regex, (match, key) => {
    return variables[key] || match
  })
}

/**
 * 通知详情
 *
 * @param param0 - 参数
 * @param param0.notification - 通知
 * @param param0.reflectionVariables - 变量
 * @returns 组件
 */
export const NoticeDetail: FC<{
  notification: Notification
  reflectionVariables?: string
}> = ({ notification, reflectionVariables }) => {
  const setting = notification.setting as { isLink?: boolean } | undefined
  const variables =
    safeParseJSON(
      reflectionVariables || notification.currentRecever?.variables || ''
    ) || {}

  const richtextValue = getNoticeRichtext(notification.content || '', variables)

  return (
    <Wrapper>
      <Header>
        <Title>{notification.title}</Title>
        <Flex>
          <Msg>
            {notification.publishedAt
              ? moment(notification.publishedAt).format('YYYY-MM-DD HH:mm')
              : ''}
          </Msg>
          <Msg>{notification.senderName || ''}</Msg>
        </Flex>
      </Header>
      <Divider style={{ margin: 0 }} />
      {!isNil(setting?.isLink) && setting?.isLink ? (
        <a
          href={notification.content}
          target="_blank"
        >
          {notification.content}
        </a>
      ) : (
        <RichTextRenderer value={richtextValue} />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: ${(p) => p.theme.text._1};
`

const Msg = styled.div`
  font-size: 16px;
  font-weight: normal;
  line-height: 28px;
  color: ${(p) => p.theme.text._3};
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
